import React, { useEffect, useRef, useState } from 'react';
import socket from '../../utils/examSocket';

export default function AdminDashboard() {
  const [students, setStudents] = useState({});
  const [selectedStudent, setSelectedStudent] = useState(null);

  const peers = useRef({});
  const videos = useRef({});
  const fullscreenVideo = useRef(null);

  const adminId = 'admin1';

  useEffect(() => {
    socket.emit('admin:join', {
      adminId,
    });

    socket.on('students:update', (list) => {
      console.log('📚 Students updated:', list);
      setStudents(list);
    });

    socket.on('webrtc:offer', async ({ offer, studentSocketId, studentId }) => {
      await receiveOffer(offer, studentSocketId, studentId);
    });

    socket.on('webrtc:ice-candidate', async ({ candidate, studentId }) => {
      const peer = peers.current[studentId];

      if (peer && candidate) {
        try {
          await peer.addIceCandidate(new RTCIceCandidate(candidate));
        } catch (err) {
          console.error('ICE error:', err);
        }
      }
    });

    return () => {
      socket.off('students:update');
      socket.off('webrtc:offer');
      socket.off('webrtc:ice-candidate');
    };
  }, []);

  useEffect(() => {
    if (selectedStudent && fullscreenVideo.current) {
      const video = videos.current[selectedStudent];

      if (video?.srcObject) {
        fullscreenVideo.current.srcObject = video.srcObject;
      }
    }
  }, [selectedStudent]);

  const watchStudent = (studentId) => {
    if (peers.current[studentId]) {
      return;
    }

    console.log('👀 Watching:', studentId);

    socket.emit('student:watch', {
      studentId,
      adminId,
    });
  };

  const watchAllStudents = () => {
    Object.keys(students).forEach((id) => {
      watchStudent(id);
    });
  };

  const receiveOffer = async (offer, studentSocketId, studentId) => {
    try {
      if (peers.current[studentId]) {
        return;
      }

      const peer = new RTCPeerConnection({
        iceServers: [
          {
            urls: 'stun:stun.l.google.com:19302',
          },
        ],
      });

      peers.current[studentId] = peer;

      peer.ontrack = (event) => {
        console.log('🎥 Stream received:', studentId);

        const video = videos.current[studentId];

        if (video) {
          video.srcObject = event.streams[0];

          if (selectedStudent === studentId && fullscreenVideo.current) {
            fullscreenVideo.current.srcObject = event.streams[0];
          }
        }
      };

      peer.onicecandidate = (event) => {
        if (event.candidate) {
          socket.emit('webrtc:ice-candidate', {
            target: studentSocketId,
            candidate: event.candidate,
            studentId,
          });
        }
      };

      await peer.setRemoteDescription(new RTCSessionDescription(offer));

      const answer = await peer.createAnswer();

      await peer.setLocalDescription(answer);

      socket.emit('webrtc:answer', {
        answer,
        studentSocketId,
      });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h1>Exam Monitoring Dashboard</h1>

      <h3>Students Online: {Object.keys(students).length}</h3>

      <button
        onClick={watchAllStudents}
        style={{
          marginBottom: 20,
        }}
      >
        Watch All Students
      </button>

      {Object.keys(students).length === 0 && <p>No students online.</p>}

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: 20,
        }}
      >
        {Object.entries(students).map(([studentId, student]) => (
          <div
            key={studentId}
            style={{
              border: '1px solid #ccc',
              borderRadius: 10,
              padding: 10,
              background: '#fff',
            }}
          >
            <h4>{student.name}</h4>

            <div>ID: {studentId}</div>

            <video
              ref={(el) => {
                if (el) {
                  videos.current[studentId] = el;
                }
              }}
              autoPlay
              playsInline
              muted
              style={{
                width: '100%',
                height: 220,
                background: '#000',
                objectFit: 'cover',
                marginTop: 10,
              }}
            />

            <div
              style={{
                marginTop: 10,
                display: 'flex',
                gap: 10,
              }}
            >
              <button onClick={() => watchStudent(studentId)}>Watch</button>

              <button onClick={() => setSelectedStudent(studentId)}>
                Full Screen
              </button>
            </div>
          </div>
        ))}
      </div>

      {selectedStudent && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,.9)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <h2
            style={{
              color: '#fff',
            }}
          >
            {students[selectedStudent]?.name}
          </h2>

          <video
            ref={fullscreenVideo}
            autoPlay
            playsInline
            controls
            style={{
              width: '90%',
              maxHeight: '80vh',
              background: '#000',
            }}
          />

          <button
            style={{
              marginTop: 20,
            }}
            onClick={() => setSelectedStudent(null)}
          >
            Close
          </button>
        </div>
      )}
    </div>
  );
}
